export default [
    {
        path: "/webview",
        name: "mobile__root__",
        hidden: true,
        meta: {
            isPublic: true,
            title: "深莓随身办",
        },
    },
    {
        path: "/webview/fms",
        name: "webview-fms",
        meta: {
            title: "市场营销",
            parent: "webview",
        },
        component: () => import("@/layouts/webview_layout.vue"),
        children: [
            {
                path: "after-sales",
                name: "webview-after-sales",
                component: () => import("@/views/webview/fms/after-sales/index.vue"),
                meta: {
                    title: "售后工单",
                },
            },
            {
                path: "after-sales-detail/:id",
                name: "webview-after-sales-detail",
                component: () => import("@/views/webview/fms/after-sales/detail.vue"),
                meta: {
                    title: "售后工单详情",
                },
            },
            {
                path: "sign/create",
                name: "webview-fms-sign-create",
                component: () => import("@/views/webview/fms/sign/create.vue"),
                meta: {
                    title: "意向订单创建",
                },
            },
            {
                path: "sign",
                name: "webview-fms-sign",
                component: () => import("@/views/webview/fms/sign/index.vue"),
                meta: {
                    title: "签约订单",
                },
            },
            {
                path: "sign/edit/:id",
                name: "webview-fms-sign-edit",
                component: () => import("@/views/webview/fms/sign/edit.vue"),
                meta: {
                    title: "签约订单编辑",
                },
            },
            {
                path: "sign/detail/:id",
                name: "webview-fms-sign-detail",
                component: () => import("@/views/webview/fms/sign/detail.vue"),
                meta: {
                    title: "签约订单详情",
                },
            },
        ],
    },
];
